// Public build-time setting shared by the UI and all PDF reports.
export const logoPath = process.env.REACT_APP_LOGO_PATH?.trim() || `${process.env.PUBLIC_URL || ''}/branding/logo.png`;

export const loadReportLogo = async () => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 10000);
  try {
    const response = await fetch(logoPath, { signal: controller.signal, cache: 'no-store', credentials: 'same-origin' });
    if (!response.ok) throw new Error('Logo unavailable');
    const blob = await response.blob();
    if (!['image/png', 'image/jpeg'].includes(blob.type) || blob.size > 5 * 1024 * 1024) throw new Error('Invalid logo format');
    // pdfMake requires image bytes. Convert the configured file only at generation time.
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(new Error('Logo unavailable'));
      reader.readAsDataURL(blob);
    });
  } finally { clearTimeout(timeout); }
};
